import * as React from 'react';
import styled from 'styled-components';

const DEFAULT_MAX_CHARS = 120;

type Props = {
  value: any;
  maxChars?: number;
};

const TruncatedTextCell = ({
  value,
  maxChars = DEFAULT_MAX_CHARS,
}: Props) => {
  const [expanded, setExpanded] = React.useState(false);

  if (value === null || value === undefined || value === '') {
    return null;
  }

  const text = String(value);
  const needsTruncate = text.length > maxChars;

  if (!needsTruncate) {
    return <Text>{text}</Text>;
  }

  return (
    <Wrapper>
      <Text $clamped={!expanded}>
        {expanded ? text : `${text.slice(0, maxChars).trimEnd()}…`}
      </Text>
      <ToggleButton
        type="button"
        onClick={() => setExpanded(prev => !prev)}
      >
        {expanded ? 'Show less' : 'Show more'}
      </ToggleButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  max-width: 360px;
`;

const Text = styled.span<{ $clamped?: boolean }>`
  display: block;
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--mainText);
  white-space: pre-wrap;
  word-break: break-word;
`;

const ToggleButton = styled.button`
  align-self: flex-start;
  padding: 0;
  background: none;
  border: none;
  color: var(--primary-700);
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: var(--primary-800, var(--primary-700));
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
    border-radius: 4px;
  }
`;

export default TruncatedTextCell;
